@if (config.tooltip) {
  <div class="tooltip-section">
    <label>{{ config.labelTooltip }}</label>
    <mat-icon
      matTooltip="Orientação de preenchimento: {{ config.tooltipText }}"
      matTooltipPosition="above">
      help_outline
    </mat-icon>
  </div>
}

<mat-form-field
  appearance="outline"
  [formGroup]="formGroup"
  style="margin-bottom: -1.25em; width: 100%"
  >
  <mat-label>{{ config.label }}</mat-label>

  <div>
    <mat-select
      uiSemItemAtivo
      [formControl]="controle"
      [multiple]="config.multiple"
      (selectionChange)="atualizaControle($event)"
      matTooltip="{{ getTooltipAdaptado() }}"
      >
      @if (config.multiple) {
        <mat-select-trigger>
          {{ textoResumido }}
        </mat-select-trigger>
      }

      @if (!config.esconderFiltro) {
        <input
          matInput
          type="text"
          placeholder="Filtro"
          class="campo-painel"
          (keyup)="filtrarValores($event.target.value)"
          />
      }

      @if (config.multiple && controle.value?.length) {
        <input
          matInput
          type="text"
          placeholder="Limpar seleção"
          class="campo-painel"
          (click)="limparSelecao($event)"
          style="cursor: pointer"
          />
      }

      @if (!config.multiple) {
        <mat-option>
          Selecione
        </mat-option>
      }

      @for (option of listaCompleta; track option) {
        <mat-option
          [value]="option.value"
          [hidden]="!isVisivel(option)"
          [matTooltip]="tooltipTextoLongo(option.text)"
          >
          {{ textoLimitado(option.text) }}
        </mat-option>
      }

    </mat-select>
  </div>
</mat-form-field>
